import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import ErrorHandler from "../../helpers/ErrorHandler";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faCopy, faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { NotificationMessage, ShortUrl } from "../../helpers/Types";
import { AxiosError, AxiosInstance, AxiosResponse } from "axios";

interface ShortUrlListrops {
  setNotificationMessage: (notificationMessage: NotificationMessage) => void;
  api: AxiosInstance;
  updateUsername: (username: string) => void;
}

export default function ShortUrlList({ setNotificationMessage, api, updateUsername }: ShortUrlListrops) {
  const navigate = useNavigate();
  const [shortUrls, setShortUrls] = useState([]);

  useEffect(() => {
    api
      .get(`short_url/list`)
      .then((response: AxiosResponse) => {
        if (response.data) setShortUrls(response.data);
      })
      .catch((error: AxiosError) => {
        ErrorHandler(error, setNotificationMessage);
        updateUsername("");
        navigate("/login");
      });
  }, [api, navigate, setNotificationMessage, updateUsername]);

  const renderShortUrls = shortUrls.map((short_url: ShortUrl) => {
    return (
      <div className="pb-2" key={short_url.code.S}>
        <Link className="text-decoration-none fw-bold" to={{ pathname: `/short-url/${short_url.code.S}/detail` }}>
          {short_url.label.S}
        </Link>
        <Link target={"_blank"} className="ps-2 float-left" to={{ pathname: `/short-url/${short_url.code.S}` }}>
          <FontAwesomeIcon icon={faExternalLinkAlt} />
        </Link>
        <Link
          className="ps-2 float-left"
          to="/#"
          onClick={(e: React.MouseEvent) => {
            navigator.clipboard.writeText(window.location.origin + `/short-url/${short_url.code.S}`);
            e.preventDefault();
          }}
        >
          <FontAwesomeIcon icon={faCopy} />
        </Link>
      </div>
    );
  });

  return (
    <div className="p-3 m-1 border rounded bg-white">
      <div>
        <div className="pb-3">
          <Link className="text-decoration-none bold" to={{ pathname: `/short-url/create` }}>
            <FontAwesomeIcon icon={faPlusCircle} size="lg" />
          </Link>
        </div>
        <div className="text-center">
          <h3>Short URLs</h3>
        </div>
        <div className="text-center my-3 text-capitalize">{renderShortUrls}</div>
      </div>
    </div>
  );
}
